const ENABLED = 'enabled';
const CAN_SET = 'canSet';
const CAN_UNSET = 'canUnset';

export {ENABLED, CAN_SET, CAN_UNSET};
